import { render, staticRenderFns } from "./sub-product-multiselect.vue?vue&type=template&id=4f695174&scoped=true&"
import script from "./sub-product-multiselect.vue?vue&type=script&lang=js&"
export * from "./sub-product-multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f695174",
  null
  
)

export default component.exports